export enum RoutesEnum {
  // generic
  ALL = "*",
  DEFAULT = "",
  ERROR = "error",
  BASIC = "/",

  // Login Page
  APICALLBACK = "api_callback",
  FORGOTUSERNAME = "forgotusername",
  FORGOTPASSWORD = "forgotpassword",
  RESETPASSWORD = "resetpassword",
  SESSIONTIMEOUTPAGE = "sessiontimeoutpage",

  // tracker
  TRACKER = "tracker",
  SETTINGS = "settings",
  CASETRACKER = "caseTracker",
  LANDING = "landing",
  // ADMINSETTINGS ="adminsettings",

  // Prospecting
  TRACKER_DETAILSPAGE = "trackerDetailsPage",

  MESSAGE_CENTER = "messagecenter",
  DASHBOARD = "dashboard",

  PROSPECTINGTRACKER_DETAILSPAGE = "PROSPECTINGTRACKER_DETAILSPAGE",
  UNAUTHORIZED = "accessDenied",
  QUESTIONNAIRE = "questionnaire",

  // docuSign
  DOCU_SIGN_INIT = "docuSignInit",
  DOCU_SIGN_REDIRECT = "docuSign",
  //
  COMPLIANCE_VIEW="complianceView",
  

  // Questionarie
  CLIENT_QUESTIONARIE="clientQuestionarie",

  //pricingSheet
  PRICING_SHEET="pricingSheet"
}

export enum QUESTIONNAIRE_TYPES {
  NDA = "nda",
  CONTRACT = "contract",
  DDA = 'dda',
  PAYMENT='payments'
}


export enum CLIENT_SCREEN_TYPES {
  CLIENT_VIEW = "clientview",
  COMPLIANCE_VIEW = "compview"
}
